// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ng-scrollbar {
  --scrollbar-size: 8px;
  --scrollbar-thumb-color: rgba(94, 175, 255, 0.5);
  --scrollbar-thumb-hover-color: dodgerblue;
  --scrollbar-border-radius: 4px;
  /* border: 1px solid gray; */
}

.frozen-row {
  position: sticky;
  z-index: 50;
}

.cdk-drag-placeholder {
  opacity: 0;
  display: none;
}

.shadow {
  border: solid 1px rgba(134, 128, 145, 0.24);
  border-radius: 4px;
  min-width: 60px;
  height: 60px !important;
}

.red-shadow {
  border: solid 1px rgba(255, 0, 34, 0.24);
}

.frozen-container {
  overflow-x: scroll;
  position: relative;
  box-shadow: 0 5px 5px 1px rgba(0, 0, 0, 0.1);
}
.frozen-container table, .frozen-container th, .frozen-container td {
  border: 5px solid transparent;
}

.new-tile-block {
  min-width: 62px;
  height: 60px !important;
}

.cdk-drag-preview {
  display: inline-block;
  align-items: center;
  justify-content: center;
  font-weight: bolder;
  font-stretch: normal;
  font-size: 1.6837vw;
  font-style: normal;
  line-height: 76px;
  text-align: center;
  letter-spacing: normal;
  border-radius: 4px !important;
  border: solid 1px rgba(72, 30, 159, 0.24);
  padding-right: 10px;
  padding-left: 10px;
  min-width: 76px;
  min-height: 76px;
}`, "",{"version":3,"sources":["webpack://./src/core/components/tile-bank/tile-bank.scss"],"names":[],"mappings":"AAGA;EACC,qBAAA;EACA,gDAAA;EACA,yCAAA;EACA,8BAAA;EACC,4BAAA;AAFF;;AAIE;EACE,gBAAA;EACA,WAAA;AADJ;;AAKE;EACE,UAAA;EACA,aAAA;AAFJ;;AAIA;EACI,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;AADJ;;AAKE;EACE,wCAAA;AAFJ;;AAIE;EAKE,kBAAA;EAEA,kBAAA;EAEA,4CAAA;AANJ;AAFI;EACE,6BAAA;AAIN;;AAIE;EACE,eAAA;EACA,uBAAA;AADJ;;AAGE;EACE,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAAJ","sourcesContent":["// .frozen {\n//     background-color: white !important;\n// }\nng-scrollbar {\n\t--scrollbar-size: 8px;\n\t--scrollbar-thumb-color: rgba(94, 175, 255, 0.5);\n\t--scrollbar-thumb-hover-color: dodgerblue;\n\t--scrollbar-border-radius: 4px;\n\t /* border: 1px solid gray; */\n  }\n  .frozen-row{\n    position: sticky;\n    z-index: 50;\n      //background-color: white !important;\n\n  }\n  .cdk-drag-placeholder {\n    opacity: 0;\n    display: none;\n  }\n.shadow {\n    border: solid 1px rgba(134, 128, 145, 0.24);\n    border-radius: 4px;\n    min-width: 60px;\n    height: 60px !important;\n\n  }\n\n  .red-shadow {\n    border: solid 1px rgba(255, 0, 34, 0.24);\n  }\n  .frozen-container {\n    table, th, td {\n      border: 5px solid transparent;\n    }\n\n    overflow-x: scroll;\n    // padding-left: 1.4%;\n    position: relative;\n    -webkit-box-shadow: 0 5px 5px 1px rgba(0,0,0,0.1);\n    box-shadow: 0 5px 5px 1px rgba(0,0,0,0.1);  }\n  .new-tile-block {\n    min-width: 62px;\n    height: 60px !important;\n  }\n  .cdk-drag-preview {\n    display: inline-block;\n    align-items: center;\n    justify-content: center;\n    font-weight: bolder;\n    font-stretch: normal;\n    font-size: 1.6837vw;\n    font-style: normal;\n    line-height: 76px;\n    text-align: center;\n    letter-spacing: normal;\n    border-radius: 4px !important;\n    border: solid 1px rgba(72, 30, 159, 0.24);\n    padding-right: 10px;\n    padding-left: 10px;\n    min-width: 76px;\n    min-height: 76px;  }\n//   .cdk-drop-list-receiving {\n// \t  opacity: 0;\n//   }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
